import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import HomePage from './pages/Home';
import MenuPage from './pages/Menu';
import PhrasePage from './pages/Phrase';
import ExchangePage from './pages/Exchange';
import ScrollToTop from './components/ScrollToTop';
import './transitions.css';

// 创建一个包含动画的路由组件
function AnimatedRoutes() {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<HomePage />} />
        <Route path="/menu" element={<MenuPage />} />
        <Route path="/phrase" element={<PhrasePage />} />
        <Route path="/exchange" element={<ExchangePage />} />
      </Routes>
    </AnimatePresence>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <AnimatedRoutes />
    </BrowserRouter>
  );
}

export default App; 